import {spawnErrorToast} from '@hm/fundamental'
import type {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import type {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

export const useRefractoryQuery = ({
  refractoryId,
  enabled = true
}: {
  refractoryId: number
  enabled?: boolean
}) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'refractory',
    params: [{refractoryId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useRefractoryQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching refractories data')

      spawnErrorToast(t('error.refractoryQuery'))

      return false
    },
    enabled
  })
}
